module.exports = __webpack_public_path__ + "img/how-works-thumb.196b43dc.png";